import { usePrivacyConsentMutation } from "@api/user";
import Header from "@components/Header";
import { useLogout, useUserData } from "@hooks/auth";
import { SupportedLanguage } from "@onetutor/shared/type";
import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router";
import privacyConsentDE from "./privacyConsent.de.md?raw";
import privacyConsentEN from "./privacyConsent.en.md?raw";

function PrivacyConsentPage() {
  const auth = useAuth();
  const [updatePrivacyConsent] = usePrivacyConsentMutation();
  const navigate = useNavigate();
  const user = useUserData();

  const { t, i18n } = useTranslation(["privacyConsentPage"]);
  const [isChecked, setIsChecked] = useState(false);

  const logout = useLogout();

  const privacyConsent =
    i18n.language === SupportedLanguage.EN
      ? privacyConsentEN
      : privacyConsentDE;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!auth.user) {
      await logout();
      return;
    }
    await updatePrivacyConsent();
  };

  useEffect(() => {
    if (user.user?.privacyConsent) {
      navigate("/");
    }
  }, [user.user, navigate]);

  return (
    <Header>
      <div className="mx-auto max-w-3xl">
        <div className="markdown">
          <ReactMarkdown>{privacyConsent}</ReactMarkdown>
        </div>
        <form className="space-y-10" onSubmit={handleSubmit}>
          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              className="checkbox checkbox-md"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />{" "}
            <p
              onClick={() => setIsChecked(!isChecked)}
              onKeyUp={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setIsChecked(!isChecked);
                }
              }}
              className="cursor-pointer"
            >
              <Trans t={t} i18nKey="privacyConsentPage:checkbox">
                I have read the{" "}
                <a
                  className="underline"
                  href="/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  terms and conditions
                </a>
                agree to it and the collection of my data.
              </Trans>
            </p>
          </div>
          <div className="flex justify-center gap-5">
            <button type="button" className="btn btn-neutral" onClick={logout}>
              {t("back")}
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isChecked}
            >
              {t("accept")}
            </button>
          </div>
        </form>
      </div>
    </Header>
  );
}

export default PrivacyConsentPage;
